import { ApiEndpoints } from "./apiEndpoints";
import { fetchData, setHeaderOptions } from "./apiHelpers";
import { ContentRow } from "./content.type";

export const getContent = async (): Promise<ContentRow[]> => {
  try {
    const slug = ApiEndpoints.content + "/";

    const options = {
      method: "GET",
    };
    const contacts = await fetchData<ContentRow[]>(slug, options);

    return contacts;
  } catch (err) {
    console.error("Error getting contacts:", err);
    throw err;
  }
};

export const getContentById = async (id: string): Promise<ContentRow> => {
  try {
    const slug = ApiEndpoints.content + `/${id}`;

    const options = {
      method: "GET",
    };
    const content = await fetchData<ContentRow>(slug, options);

    return content;
  } catch (err) {
    console.error(`Error getting contact with id ${id}:`, err);
    throw err;
  }
};

export const createContent = async (text: string): Promise<ContentRow> => {
  try {
    const slug = ApiEndpoints.content + "/";
    const options = await setHeaderOptions({
      method: "POST",
      body: { text },
    });
    const response = await fetchData<ContentRow>(slug, options);
    return response;
  } catch (err) {
    console.error("Error creating content:", err);
    throw err;
  }
};

export const generateWebSearch = async ({
  input,
  diagnosisId,
}: {
  input: string;
  diagnosisId: string;
}) => {
  try {
    const slug = ApiEndpoints.content + "/web-search";
    const options = await setHeaderOptions({
      method: "POST",
      body: {
        input,
        diagnosisId,
      },
    });
    const response = await fetchData<ContentRow>(slug, options);
    return response;
  } catch (err) {
    console.error("Error generating web search:", err);
    throw err;
  }
};

export const getContentItem = async (idOrSlug: string): Promise<ContentRow> => {
  try {
    const slug = `${ApiEndpoints.content}/${encodeURIComponent(idOrSlug)}`;

    const options = await setHeaderOptions({
      method: "GET",
    });

    const content = await fetchData<ContentRow>(slug, options);

    return content;
  } catch (err) {
    console.error("Error getting content item:", err);
    throw err;
  }
};

export const getSimilarContent = async (id: string): Promise<ContentRow[]> => {
  try {
    const slug = `${ApiEndpoints.content}/${encodeURIComponent(id)}/similar`;
    const options = await setHeaderOptions({
      method: "GET",
    });
    const similar = await fetchData<ContentRow[]>(slug, options);
    return similar;
  } catch (err) {
    console.error(`Error getting similar content for ${id}:`, err);
    throw err;
  }
};

export const shareContent = async ({
  contentId,
  contactId,
}: {
  contentId: string;
  contactId: string;
}): Promise<string> => {
  try {
    const slug = ApiEndpoints.content + "/share";
    const options = setHeaderOptions({
      method: "POST",
      body: { contentId, contactId },
    });
    const response = await fetchData<string>(slug, options);
    return response;
  } catch (err) {
    console.error("Error sharing content:", err);
    throw err;
  }
};

export const regenerateContentImages = async (
  id: string
): Promise<ContentRow> => {
  try {
    const slug = `${ApiEndpoints.content}/${id}/generate-images`;
    const options = await setHeaderOptions({
      method: "POST",
    });
    return await fetchData<ContentRow>(slug, options);
  } catch (err) {
    console.error("Error regenerating images:", err);
    throw err;
  }
};

export const regenerateContentText = async (
  id: string
): Promise<ContentRow> => {
  try {
    const slug = `${ApiEndpoints.content}/${id}/regenerate-text`;
    const options = await setHeaderOptions({
      method: "POST",
    });
    return await fetchData<ContentRow>(slug, options);
  } catch (err) {
    console.error("Error regenerating text:", err);
    throw err;
  }
};
